"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCrossellModule = void 0;
const initializer_1 = require("../../initializer");
const useCrossellModuleBase_hook_1 = require("./useCrossellModuleBase.hook");
const tracker_1 = require("../../tracker");
const useCrossellModule = (crossellDataParams, crossellConfig) => {
    return (0, useCrossellModuleBase_hook_1.useCrossellModuleBase)(initializer_1.API, tracker_1.tracker, crossellDataParams, crossellConfig);
};
exports.useCrossellModule = useCrossellModule;
//# sourceMappingURL=useCrossellModule.hook.js.map